module.exports = __webpack_public_path__ + "static/media/esco-logo.f4a2f039.svg";